import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormFields, FormTextField, FormActions } from "sprint-common-web";

import { MovieContentSubtype } from "../../../../common/types/MovieContentSubtype";
import { MovieItem } from "../MovieItem";
import { AddMovieFormInputs } from "./CreateMovieFormInputs";
import { useCreateMovieForm } from "./useCreateMovieForm";

export interface CreateMovieFormProps {
    contentType: MovieContentSubtype;
    onCancel(): void;
    onSubmit(newMovie: MovieItem): void;
}

export const CreateMovieForm: FunctionComponent<CreateMovieFormProps> = (props: CreateMovieFormProps) => {
    const { contentType, onCancel, onSubmit } = props;

    const { handleSubmit, errors, control, formState, reset } = useForm<AddMovieFormInputs>({
        defaultValues: {
            title: ""
        },
        criteriaMode: "all"
    });

    const { createNewMovie, validateTitle } = useCreateMovieForm(contentType);

    const createMovie = async (inputs: AddMovieFormInputs) => {
        const newItem = await createNewMovie(inputs);
        onSubmit(newItem);
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(createMovie)}>
            <FormFields>
                <FormTextField
                    label="Title"
                    control={control}
                    name="title"
                    errors={errors}
                    rules={{ required: "Enter correct title", validate: validateTitle }}
                />
            </FormFields>
            <FormActions
                isLoading={formState.isSubmitting || formState.isValidating}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
